function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 32C7.177 32 0 24.823 0 16S7.177 0 16 0s16 7.177 16 16-7.177 16-16 16z",
  fill: "#00A458"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 21.333a.992.992 0 01-.707-.293L9.46 16.707a1 1 0 011.415-1.415l3.626 3.627 7.96-7.96a1 1 0 011.415 1.414l-8.667 8.667a1.002 1.002 0 01-.709.293z",
  fill: "#fff"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDMyQzcuMTc3MjUgMzIgMCAyNC44MjI4IDAgMTZDMCA3LjE3NzI1IDcuMTc3MjUgMCAxNiAwQzI0LjgyMjggMCAzMiA3LjE3NzI1IDMyIDE2QzMyIDI0LjgyMjggMjQuODIyOCAzMiAxNiAzMloiIGZpbGw9IiMwMEE0NTgiLz4KPHBhdGggZD0iTTE0LjUgMjEuMzMzM0MxNC4yNDM5IDIxLjMzMzMgMTMuOTg4IDIxLjIzNjEgMTMuNzkzMiAyMS4wNEw5LjQ1OTk2IDE2LjcwNjhDOS4wNjkzNCAxNi4zMTU5IDkuMDY5MzQgMTUuNjgyNiA5LjQ1OTk2IDE1LjI5MkM5Ljg1MDU5IDE0LjkwMTQgMTAuNDgzOSAxNC45MDE0IDEwLjg3NDggMTUuMjkyTDE0LjUwMTIgMTguOTE4N0wyMi40NjE0IDEwLjk1ODdDMjIuODUyMSAxMC41NjgxIDIzLjQ4NTQgMTAuNTY4MSAyMy44NzYgMTAuOTU4N0MyNC4yNjY2IDExLjM0OTQgMjQuMjY2NiAxMS45ODI3IDIzLjg3NiAxMi4zNzMzTDE1LjIwOTIgMjEuMDRDMTUuMDEyIDIxLjIzNjEgMTQuNzU2MSAyMS4zMzMzIDE0LjUgMjEuMzMzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgCheck as ReactComponent };